<template>
  <ProductBuyDetail v-if="hasFinancingEnabled">
    <template v-slot:icon>
      <span class="product-financing-dollar"><DollarImage /></span>
    </template>
    <template v-slot:text>
      <div class="product-financing" :class="{ skeleton: !loaded }">
        <FinancingMessage v-if="mounted" :price="amountInCents" :accent-link="true" :showContentfulMessage="true" @loaded="loaded=true" :useSkeleton="false" />
        <span v-if="!mounted && !loaded">&nbsp;</span>
      </div>
    </template>
  </ProductBuyDetail>
</template>

<script>
import useFinancing from '@/compositions/useFinancing';
import ProductBuyDetail from '@/components/product/ProductBuyDetail.vue';
import DollarImage from '@/assets/product/dollar.svg';
import useLifecycleHook from '@/compositions/useLifecycleHook';
import FinancingMessage from '@/components/commons/FinancingMessage.vue';
import { computed } from 'vue';

export default {
  name: 'ProductFinancing',
  components: {
    FinancingMessage,
    ProductBuyDetail,
    DollarImage,
  },
  data() {
    return {
      loaded: false,
    };
  },
  props: {
    amountInCents: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { mounted } = useLifecycleHook();

    const { isEnabled: isFinancingEnabled } = useFinancing();
    const hasFinancingEnabled = computed(() => isFinancingEnabled(props.amountInCents / 100));

    return {
      mounted,
      hasFinancingEnabled,
    };
  },
  computed: {
    showDivider() {
      return this.hasAvailableFinancingProvider;
    },
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';

.product-financing-dollar {
  width: 18px;
  height: 18px;
}

.product-financing {
  &.skeleton {
    /* max-width: 250px;
    height: 1.5em; */
    * {
      visibility: hidden;
    }
  }
}
</style>
